import React from 'react';
const Error=({errorMgs,warningMsg})=>{
return(<>{
    errorMgs?<div className="d-flex align-items-center mt-3 gap-md">
      <div style={{maxWidth:'40px'}}>
              <div className="error-message-dot">!</div>
       </div>       
              <div className="text-error-message regular-bold"> {errorMgs}</div>
            </div>:<div></div>
}
{
    warningMsg?<div className="d-flex align-items-center mt-3 gap-md">
      <div style={{maxWidth:'40px'}}>
              <div className="warning-message-dot">!</div>
       </div>       
              <div className="text-warning-message regular-bold"> {warningMsg}</div>
            </div>:<div></div>
}
</>)
}
export default Error